export default "__VITE_ASSET__COHPRuV4__"